export default "__VITE_ASSET__D11j53W6__";